import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApActionIconComponent, ApIconComponent } from '@ap/icon';
import { ApIconButtonLinkComponent, ApIconLinkComponent } from '@ap/icon-link';
import { MijnAnalyseModule } from '@ap/mijn-analyse';

import { ConversationalModule } from '../mijn-overzicht-template';

import { ContextHelpModalModule } from './context-help-modal/context-help-modal.module';
import { MijnActieTemplateComponent } from './mijn-actie-template.component';

/**
 * @name MijnActieTemplateModule
 *
 * @ngdoc module
 */
@NgModule({
    declarations: [MijnActieTemplateComponent],
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApIconLinkComponent,
        ApIconComponent,
        ApActionIconComponent,
        ApIconButtonLinkComponent,
        CommonModule,
        ContextHelpModalModule,
        ConversationalModule,
        MijnAnalyseModule
    ],
    exports: [MijnActieTemplateComponent]
})
export class MijnActieTemplateModule {}
